/**
 * 토스트 메시지 상수 정의
 * 데스크톱과 모바일에서 공통으로 사용되는 메시지들
 */
export const TOAST_MESSAGES = {
    login: {
        no_email: '해당 이메일로 가입된 계정이 없습니다.이메일을 다시 한번 확인해 주세요',
        password_error: '비밀번호가 틀렸어요',
        email_or_password_error: '이메일 또는 비밀번호가 틀렸어요',
        copy_email: '이메일 주소를 복사했어요',
        email_already_exists: '이미 가입된 이메일이에요',
        verification_email_resent: '인증메일을 재전송했어요',
        verification_code_mismatch: '인증번호가 일치하지 않아요, 다시 확인해주세요',
        verification_expired: '유효시간이 만료됐어요, 인증메일 재전송을 눌러주세요',
        email_verification_complete: '이메일 인증이 완료됐어요',
        file_size_exceeded: '파일 용량이 초과됐어요',
        file_type_error: '허용되지 않는 파일 형식이에요',
    },
    order: {
        order_success: '주문이 실행되었습니다',
        full_liquidation: '전량 청산되었습니다',
        liquidation_complete: '청산이 완료되었습니다',
        order_modified: '정정되었습니다',
        full_cancellation: '전량 취소되었습니다',
    },
    account: {
        account_created: '계좌 개설이 완료되었습니다',
        account_creation_cancelled: '계좌 개설이 취소되었습니다',
        info_change_complete: '정보 변경이 완료됐어요',
        enter_account_info: '계좌 정보를 입력해주세요',
        check_previous_password: '이전 비밀번호를 확인해주세요',
        password_mismatch: '계좌 비밀번호가 일치하지 않아요',
        attach_transfer_receipt: '송금내역서를 첨부해주세요',
    },
    user: {
        personal_info_changed: '개인정보가 변경되었습니다.',
        verification_code_confirmed: '인증번호가 확인되었어요',
        verification_code_incorrect: '인증번호가 틀렸어요. 다시 확인해주세요',
        password_changed_successfully: '비밀번호가 성공적으로 변경되었어요',
    },
};
//# sourceMappingURL=toast-messages.js.map